import { render, staticRenderFns } from "./EditConfigOptions.vue?vue&type=template&id=6005791a&"
import script from "./EditConfigOptions.vue?vue&type=script&lang=js&"
export * from "./EditConfigOptions.vue?vue&type=script&lang=js&"
import style0 from "./EditConfigOptions.vue?vue&type=style&index=0&id=6005791a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports